// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* HTML DataTable Styles - Modern & Beautiful */

.html-data-table-container {
  width: 100%;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

/* Controls Bar */
.html-data-table-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  flex-wrap: wrap;
  gap: 12px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-bottom: 1px solid #e9ecef;
}

.entries-per-page {
  display: flex;
  align-items: center;
  gap: 8px;
}

.entries-select {
  padding: 6px 12px;
  border: 1px solid #dee2e6;
  background: white;
  font-size: 13px;
  color: #495057;
  cursor: pointer;
  min-width: 70px;
  border-radius: 6px;
  transition: all 0.2s ease;
  font-weight: 500;
}

.entries-select:hover {
  border-color: #1976d2;
  box-shadow: 0 2px 4px rgba(25, 118, 210, 0.1);
}

.entries-select:focus {
  outline: none;
  border-color: #1976d2;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);
}

.entries-label {
  font-size: 13px;
  color: #6c757d;
  white-space: nowrap;
  font-weight: 500;
}

.search-container {
  width: 100%;
  max-width: 250px;
  margin-left: auto;
}

.search-input {
  width: 100%;
  padding: 8px 14px;
  border: 1px solid #dee2e6;
  font-size: 13px;
  border-radius: 8px;
  transition: all 0.2s ease;
  background: white;
}

.search-input:focus {
  outline: none;
  border-color: #1976d2;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);
}

.search-input::placeholder {
  color: #adb5bd;
}

/* Table Wrapper */
.html-data-table-wrapper {
  overflow-x: auto;
  border-radius: 12px;
}

.html-data-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: white;
}

.html-data-table thead th {
  padding: 12px 14px;
  font-weight: 600;
  font-size: 11px;
  color: #64748b;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
  position: relative;
  background: #f8fafc;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.html-data-table thead th:first-child {
  border-top-left-radius: 12px;
}

.html-data-table thead th:last-child {
  border-top-right-radius: 12px;
}

.html-data-table thead th.sortable-header {
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.html-data-table thead th.sortable-header:hover {
  background: #eef2ff;
  color: #4d7cfe;
}

/* Allow React elements in header and cells to handle their own clicks */
.html-data-table thead th > *,
.html-data-table tbody td > * {
  pointer-events: auto;
}

.html-data-table thead th > div,
.html-data-table tbody td > div {
  pointer-events: auto;
  min-height: 1px; /* Ensure divs are visible */
}

/* Ensure React elements are visible */
.html-data-table thead th > div > *,
.html-data-table tbody td > div > * {
  pointer-events: auto;
  visibility: visible;
  display: block;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  width: 100%;
}

.sort-icon {
  font-size: 12px;
  color: #adb5bd;
  margin-left: 6px;
  transition: color 0.2s ease;
}

.sort-asc,
.sort-desc {
  color: #4d7cfe;
  font-weight: bold;
}

.html-data-table tbody tr {
  border-bottom: 1px solid #f1f3f5;
  transition: all 0.2s ease;
  background: white;
}

.html-data-table tbody tr:nth-child(even) {
  background: #f3f5f7;
}

.table-check {
  position: relative;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  margin: 0;
  cursor: pointer;
}

.table-check input {
  position: absolute;
  inset: 0;
  opacity: 0;
  margin: 0;
  cursor: pointer;
}

.table-check-box {
  width: 18px;
  height: 18px;
  border-radius: 6px;
  border: 1.5px solid #cbd5e1;
  background: #fff;
  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.04);
  display: flex !important;
  align-items: center;
  justify-content: center;
  transition: background 160ms ease, border-color 160ms ease, box-shadow 160ms ease;
}

.table-check-box::after {
  content: "";
  display: block;
}

.table-check:hover .table-check-box {
  border-color: #4d7cfe;
  box-shadow: 0 0 0 3px rgba(77, 124, 254, 0.12);
}

.table-check input:checked + .table-check-box,
.table-check input:indeterminate + .table-check-box {
  background: #4d7cfe;
  border-color: #4d7cfe;
  box-shadow: 0 4px 10px rgba(77, 124, 254, 0.28);
}

.table-check input:checked + .table-check-box::after {
  width: 5px;
  height: 9px;
  margin-top: -1px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.table-check input:indeterminate + .table-check-box::after {
  width: 8px;
  height: 2px;
  border: none;
  background: #fff;
  border-radius: 2px;
  transform: none;
}

.html-data-table tbody tr:hover {
  background-color: #eef2ff !important;
}

.html-data-table tbody tr:hover td:not(.date-column) {
  background-color: transparent !important;
}

.html-data-table tbody td {
  padding: 12px 14px;
  font-size: 13px;
  color: #334155;
  vertical-align: middle;
  line-height: 1.45;
  font-family: Inter, "Public Sans", Roboto, Helvetica, Arial, sans-serif;
}

.tc-stack {
  display: flex !important;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
}

.tc-row {
  display: flex !important;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.tc-text {
  margin: 0;
  color: #1e293b;
  font-size: 13px;
  font-weight: 600;
}

.tc-muted {
  margin: 0;
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
}

.tc-label {
  min-width: 52px;
  color: #94a3b8;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.tc-empty {
  color: #94a3b8;
  font-size: 12px;
  font-style: italic;
  border-bottom: 1px dashed #cbd5e1;
}

.tc-link {
  color: #1e293b;
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
}

.tc-link:hover {
  color: #4d7cfe;
}

.tc-sku {
  color: #94a3b8;
  font-size: 11px;
}

.tc-chip {
  display: inline-flex;
  align-items: center;
  max-width: 160px;
  padding: 2px 7px;
  overflow: hidden;
  border-radius: 6px;
  background: #f1f5f9;
  color: #475569;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tc-chip--ok {
  background: #ecfdf5;
  color: #047857;
}

.tc-chip--warn {
  background: #fff7ed;
  color: #c2410c;
}

.tc-chip--danger {
  background: #fef2f2;
  color: #b91c1c;
}

.tc-chip--info {
  background: #eef2ff;
  color: #3730a3;
}

.tc-chip--transit {
  background: #ecfeff;
  color: #0e7490;
}

.tc-size {
  display: block;
  width: 100%;
  color: #475569;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.45;
  white-space: normal;
  overflow: visible;
  word-break: break-word;
}

.tc-size-html {
  display: inline;
}

.tc-size a,
.tc-size-html a {
  color: #1d4ed8;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.tc-size img,
.tc-size-html img {
  max-width: 300px;
  height: auto;
  vertical-align: middle;
}

.tc-money {
  color: #0f172a;
  font-size: 13px;
  font-weight: 700;
}

.tc-money--ok {
  color: #047857;
}

.tc-money--link {
  color: #4d7cfe;
  cursor: pointer;
}

.tc-thumb {
  width: 56px;
  height: 56px;
  object-fit: contain;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  padding: 3px;
}

.tc-icon-btn {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  min-width: 26px;
  padding: 0;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
  background: #eef2f7;
  color: #334155;
  cursor: pointer;
  flex-shrink: 0;
  box-sizing: border-box;
}

.tc-icon-btn svg {
  width: 15px !important;
  height: 15px !important;
  font-size: 15px !important;
}

.tc-icon-btn:hover {
  border-color: #4d7cfe;
  color: #4d7cfe;
  background: #e8eeff;
}

.tc-design {
  display: inline-flex !important;
  align-items: center;
  gap: 5px;
  color: #4d7cfe;
  font-size: 12px;
  font-weight: 500;
  text-decoration: none;
}

.tc-design:hover {
  color: #3b68f0;
}

.tc-action {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: #4d7cfe;
  color: #fff;
  cursor: pointer;
}

.tc-action:hover {
  background: #3b68f0;
}

.tc-warn-box {
  padding: 4px 8px;
  border-radius: 6px;
  background: #fff7ed;
}

.html-data-table tbody td.no-end-border {
  border-bottom: none;
}

.no-data {
  text-align: center;
  padding: 48px 16px !important;
  color: #adb5bd;
  font-style: italic;
  font-size: 14px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
}

/* Footer */
.html-data-table-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  flex-wrap: wrap;
  gap: 16px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-top: 1px solid #e9ecef;
  border-radius: 0 0 12px 12px;
}

.total-entries {
  font-size: 13px;
  color: #6c757d;
  font-weight: 500;
}

/* Pagination */
.pagination {
  display: flex;
  align-items: center;
  gap: 2px;
  flex: 1 1;
  flex-wrap: nowrap;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
}

.pagination-ellipsis {
  min-width: 16px;
  padding: 0 2px;
  color: #94a3b8;
  -webkit-user-select: none;
          user-select: none;
  line-height: 36px;
}

.pagination-btn {
  min-width: 36px;
  height: 36px;
  padding: 0 12px;
  border: 1px solid #dee2e6;
  background: white;
  color: #495057;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.pagination-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-color: #1976d2;
  color: #1976d2;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(25, 118, 210, 0.15);
}

.pagination-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  background: #f8f9fa;
}

.pagination-btn.active {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  color: white;
  border-color: #1976d2;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.3);
}

.page-input {
  width: 50px;
  height: 36px;
  padding: 0 8px;
  border: 1px solid #dee2e6;
  text-align: center;
  font-size: 13px;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.page-input:focus {
  outline: none;
  border-color: #1976d2;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);
}

/* Responsive Design */
@media (max-width: 768px) {
  .html-data-table-controls {
    flex-direction: column;
    align-items: stretch;
  }

  .entries-per-page {
    width: 100%;
  }

  .search-container {
    width: 100%;
    max-width: 100%;
    margin-left: 0;
  }

  .html-data-table-footer {
    flex-direction: column;
    align-items: stretch;
  }

  .total-entries {
    text-align: center;
  }

  .pagination {
    justify-content: center;
    flex-wrap: nowrap;
  }

  .html-data-table {
    font-size: 12px;
  }

  .html-data-table thead th,
  .html-data-table tbody td {
    padding: 6px 8px;
  }
}

/* Print Styles */
@media print {
  .html-data-table-controls,
  .html-data-table-footer {
    display: none;
  }

  .html-data-table {
    border: 1px solid #000;
  }

  .html-data-table thead th {
    background: #f5f5f5 !important;
    color: #000 !important;
    border-bottom: 1px solid #000;
  }
}
`, "",{"version":3,"sources":["webpack://./src/examples/Tables/HTMLDataTable/styles.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wEAAwE;AACxE;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;EACpB,eAAe,EAAE,4BAA4B;AAC/C;;AAEA,sCAAsC;AACtC;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,kDAAkD;EAClD,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,iFAAiF;AACnF;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,uEAAuE;AACzE;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,6DAA6D;AAC/D;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,SAAS;EACT,6DAA6D;EAC7D,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;AACF;;AAEA,iBAAiB;AACjB;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;IAC9B,sBAAsB;IACtB,6BAA6B;EAC/B;AACF","sourcesContent":["/* HTML DataTable Styles - Modern & Beautiful */\n\n.html-data-table-container {\n  width: 100%;\n  background: #fff;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n}\n\n/* Controls Bar */\n.html-data-table-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  flex-wrap: wrap;\n  gap: 12px;\n  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);\n  border-bottom: 1px solid #e9ecef;\n}\n\n.entries-per-page {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.entries-select {\n  padding: 6px 12px;\n  border: 1px solid #dee2e6;\n  background: white;\n  font-size: 13px;\n  color: #495057;\n  cursor: pointer;\n  min-width: 70px;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  font-weight: 500;\n}\n\n.entries-select:hover {\n  border-color: #1976d2;\n  box-shadow: 0 2px 4px rgba(25, 118, 210, 0.1);\n}\n\n.entries-select:focus {\n  outline: none;\n  border-color: #1976d2;\n  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);\n}\n\n.entries-label {\n  font-size: 13px;\n  color: #6c757d;\n  white-space: nowrap;\n  font-weight: 500;\n}\n\n.search-container {\n  width: 100%;\n  max-width: 250px;\n  margin-left: auto;\n}\n\n.search-input {\n  width: 100%;\n  padding: 8px 14px;\n  border: 1px solid #dee2e6;\n  font-size: 13px;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  background: white;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #1976d2;\n  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);\n}\n\n.search-input::placeholder {\n  color: #adb5bd;\n}\n\n/* Table Wrapper */\n.html-data-table-wrapper {\n  overflow-x: auto;\n  border-radius: 12px;\n}\n\n.html-data-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  background: white;\n}\n\n.html-data-table thead th {\n  padding: 12px 14px;\n  font-weight: 600;\n  font-size: 11px;\n  color: #64748b;\n  text-align: left;\n  border-bottom: 1px solid #e2e8f0;\n  white-space: nowrap;\n  position: relative;\n  background: #f8fafc;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.html-data-table thead th:first-child {\n  border-top-left-radius: 12px;\n}\n\n.html-data-table thead th:last-child {\n  border-top-right-radius: 12px;\n}\n\n.html-data-table thead th.sortable-header {\n  user-select: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.html-data-table thead th.sortable-header:hover {\n  background: #eef2ff;\n  color: #4d7cfe;\n}\n\n/* Allow React elements in header and cells to handle their own clicks */\n.html-data-table thead th > *,\n.html-data-table tbody td > * {\n  pointer-events: auto;\n}\n\n.html-data-table thead th > div,\n.html-data-table tbody td > div {\n  pointer-events: auto;\n  min-height: 1px; /* Ensure divs are visible */\n}\n\n/* Ensure React elements are visible */\n.html-data-table thead th > div > *,\n.html-data-table tbody td > div > * {\n  pointer-events: auto;\n  visibility: visible;\n  display: block;\n}\n\n.header-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 4px;\n  width: 100%;\n}\n\n.sort-icon {\n  font-size: 12px;\n  color: #adb5bd;\n  margin-left: 6px;\n  transition: color 0.2s ease;\n}\n\n.sort-asc,\n.sort-desc {\n  color: #4d7cfe;\n  font-weight: bold;\n}\n\n.html-data-table tbody tr {\n  border-bottom: 1px solid #f1f3f5;\n  transition: all 0.2s ease;\n  background: white;\n}\n\n.html-data-table tbody tr:nth-child(even) {\n  background: #f3f5f7;\n}\n\n.table-check {\n  position: relative;\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  margin: 0;\n  cursor: pointer;\n}\n\n.table-check input {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  margin: 0;\n  cursor: pointer;\n}\n\n.table-check-box {\n  width: 18px;\n  height: 18px;\n  border-radius: 6px;\n  border: 1.5px solid #cbd5e1;\n  background: #fff;\n  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.04);\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  transition: background 160ms ease, border-color 160ms ease, box-shadow 160ms ease;\n}\n\n.table-check-box::after {\n  content: \"\";\n  display: block;\n}\n\n.table-check:hover .table-check-box {\n  border-color: #4d7cfe;\n  box-shadow: 0 0 0 3px rgba(77, 124, 254, 0.12);\n}\n\n.table-check input:checked + .table-check-box,\n.table-check input:indeterminate + .table-check-box {\n  background: #4d7cfe;\n  border-color: #4d7cfe;\n  box-shadow: 0 4px 10px rgba(77, 124, 254, 0.28);\n}\n\n.table-check input:checked + .table-check-box::after {\n  width: 5px;\n  height: 9px;\n  margin-top: -1px;\n  border: solid #fff;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n.table-check input:indeterminate + .table-check-box::after {\n  width: 8px;\n  height: 2px;\n  border: none;\n  background: #fff;\n  border-radius: 2px;\n  transform: none;\n}\n\n.html-data-table tbody tr:hover {\n  background-color: #eef2ff !important;\n}\n\n.html-data-table tbody tr:hover td:not(.date-column) {\n  background-color: transparent !important;\n}\n\n.html-data-table tbody td {\n  padding: 12px 14px;\n  font-size: 13px;\n  color: #334155;\n  vertical-align: middle;\n  line-height: 1.45;\n  font-family: Inter, \"Public Sans\", Roboto, Helvetica, Arial, sans-serif;\n}\n\n.tc-stack {\n  display: flex !important;\n  flex-direction: column;\n  gap: 5px;\n  min-width: 0;\n}\n\n.tc-row {\n  display: flex !important;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n.tc-text {\n  margin: 0;\n  color: #1e293b;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.tc-muted {\n  margin: 0;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.tc-label {\n  min-width: 52px;\n  color: #94a3b8;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.tc-empty {\n  color: #94a3b8;\n  font-size: 12px;\n  font-style: italic;\n  border-bottom: 1px dashed #cbd5e1;\n}\n\n.tc-link {\n  color: #1e293b;\n  font-size: 13px;\n  font-weight: 500;\n  text-decoration: none;\n}\n\n.tc-link:hover {\n  color: #4d7cfe;\n}\n\n.tc-sku {\n  color: #94a3b8;\n  font-size: 11px;\n}\n\n.tc-chip {\n  display: inline-flex;\n  align-items: center;\n  max-width: 160px;\n  padding: 2px 7px;\n  overflow: hidden;\n  border-radius: 6px;\n  background: #f1f5f9;\n  color: #475569;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.4;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.tc-chip--ok {\n  background: #ecfdf5;\n  color: #047857;\n}\n\n.tc-chip--warn {\n  background: #fff7ed;\n  color: #c2410c;\n}\n\n.tc-chip--danger {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.tc-chip--info {\n  background: #eef2ff;\n  color: #3730a3;\n}\n\n.tc-chip--transit {\n  background: #ecfeff;\n  color: #0e7490;\n}\n\n.tc-size {\n  display: block;\n  width: 100%;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1.45;\n  white-space: normal;\n  overflow: visible;\n  word-break: break-word;\n}\n\n.tc-size-html {\n  display: inline;\n}\n\n.tc-size a,\n.tc-size-html a {\n  color: #1d4ed8;\n  font-weight: 600;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.tc-size img,\n.tc-size-html img {\n  max-width: 300px;\n  height: auto;\n  vertical-align: middle;\n}\n\n.tc-money {\n  color: #0f172a;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.tc-money--ok {\n  color: #047857;\n}\n\n.tc-money--link {\n  color: #4d7cfe;\n  cursor: pointer;\n}\n\n.tc-thumb {\n  width: 56px;\n  height: 56px;\n  object-fit: contain;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  padding: 3px;\n}\n\n.tc-icon-btn {\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  min-width: 26px;\n  padding: 0;\n  border: 1px solid #cbd5e1;\n  border-radius: 7px;\n  background: #eef2f7;\n  color: #334155;\n  cursor: pointer;\n  flex-shrink: 0;\n  box-sizing: border-box;\n}\n\n.tc-icon-btn svg {\n  width: 15px !important;\n  height: 15px !important;\n  font-size: 15px !important;\n}\n\n.tc-icon-btn:hover {\n  border-color: #4d7cfe;\n  color: #4d7cfe;\n  background: #e8eeff;\n}\n\n.tc-design {\n  display: inline-flex !important;\n  align-items: center;\n  gap: 5px;\n  color: #4d7cfe;\n  font-size: 12px;\n  font-weight: 500;\n  text-decoration: none;\n}\n\n.tc-design:hover {\n  color: #3b68f0;\n}\n\n.tc-action {\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 8px;\n  background: #4d7cfe;\n  color: #fff;\n  cursor: pointer;\n}\n\n.tc-action:hover {\n  background: #3b68f0;\n}\n\n.tc-warn-box {\n  padding: 4px 8px;\n  border-radius: 6px;\n  background: #fff7ed;\n}\n\n.html-data-table tbody td.no-end-border {\n  border-bottom: none;\n}\n\n.no-data {\n  text-align: center;\n  padding: 48px 16px !important;\n  color: #adb5bd;\n  font-style: italic;\n  font-size: 14px;\n  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);\n}\n\n/* Footer */\n.html-data-table-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px;\n  flex-wrap: wrap;\n  gap: 16px;\n  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);\n  border-top: 1px solid #e9ecef;\n  border-radius: 0 0 12px 12px;\n}\n\n.total-entries {\n  font-size: 13px;\n  color: #6c757d;\n  font-weight: 500;\n}\n\n/* Pagination */\n.pagination {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  flex: 1;\n  flex-wrap: nowrap;\n  min-width: 0;\n  max-width: 100%;\n  overflow: hidden;\n}\n\n.pagination-ellipsis {\n  min-width: 16px;\n  padding: 0 2px;\n  color: #94a3b8;\n  user-select: none;\n  line-height: 36px;\n}\n\n.pagination-btn {\n  min-width: 36px;\n  height: 36px;\n  padding: 0 12px;\n  border: 1px solid #dee2e6;\n  background: white;\n  color: #495057;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n\n.pagination-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border-color: #1976d2;\n  color: #1976d2;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(25, 118, 210, 0.15);\n}\n\n.pagination-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n  background: #f8f9fa;\n}\n\n.pagination-btn.active {\n  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);\n  color: white;\n  border-color: #1976d2;\n  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.3);\n}\n\n.page-input {\n  width: 50px;\n  height: 36px;\n  padding: 0 8px;\n  border: 1px solid #dee2e6;\n  text-align: center;\n  font-size: 13px;\n  border-radius: 8px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.page-input:focus {\n  outline: none;\n  border-color: #1976d2;\n  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .html-data-table-controls {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .entries-per-page {\n    width: 100%;\n  }\n\n  .search-container {\n    width: 100%;\n    max-width: 100%;\n    margin-left: 0;\n  }\n\n  .html-data-table-footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .total-entries {\n    text-align: center;\n  }\n\n  .pagination {\n    justify-content: center;\n    flex-wrap: nowrap;\n  }\n\n  .html-data-table {\n    font-size: 12px;\n  }\n\n  .html-data-table thead th,\n  .html-data-table tbody td {\n    padding: 6px 8px;\n  }\n}\n\n/* Print Styles */\n@media print {\n  .html-data-table-controls,\n  .html-data-table-footer {\n    display: none;\n  }\n\n  .html-data-table {\n    border: 1px solid #000;\n  }\n\n  .html-data-table thead th {\n    background: #f5f5f5 !important;\n    color: #000 !important;\n    border-bottom: 1px solid #000;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
